module.exports = __webpack_public_path__ + "img/img31.faa11741.png";